import React from "react";
import {
  herobg,
  hiw1,
  hiw2,
  hiw3,
  hiw4,
  hiw5,
  hiw6,
  mattersbg,
  readybg,
  startbg,
  sts2,
  sts3,
  sts4,
  sts5,
  whybg,
  wim1,
  wim2,
  wim3,
  wim4,
  wim5,
} from "../Assets";
import { Link } from "react-router-dom";
import { HowItWorksCard, StepsToStart, WhyItMattersCard } from "../Components";

const howitworksData = [
  {
    imageSrc: hiw1,
    title: "ScoreSwap — Aggregated DEX Trading",
    description:
      "Find the best prices across various liquidity sources with every trade.",
  },
  {
    imageSrc: hiw2,
    title: "Nads Trading Bot — Telegram Terminal",
    description:
      "Trade from anywhere, anytime, with the same aggregation power as ScoreSwap.",
  },
  {
    imageSrc: hiw3,
    title: "Onchain Reputation Layer",
    description:
      "Filter bots, verify users, and build trust for governance and airdrops.",
  },
  {
    imageSrc: hiw4,
    title: "Real-Time Price Scanning",
    description:
      "Markets move fast — so do we, scanning constantly for optimal execution.",
  },
  {
    imageSrc: hiw5,
    title: "Multi-Pool Routing",
    description: "Reduce slippage by splitting trades across liquidity pools.",
  },
  {
    imageSrc: hiw6,
    title: "Permissionless Access",
    description: "No KYC. No barriers. Just connect and trade.",
  },
];

const whyitmattersCard = [
  {
    imageSrc: wim1,
    title: "Fair Airdrops",
    description: "Reward genuine users only.",
  },
  {
    imageSrc: wim2,
    title: "Best Execution",
    description: "Never overpay or undersell.",
  },
  {
    imageSrc: wim3,
    title: "Credible Governance",
    description: "Weight votes by real participation.",
  },
  {
    imageSrc: wim4,
    title: "DeFi Anywhere",
    description: "Browser or Telegram, you choose.",
  },
  {
    imageSrc: wim5,
    title: "Smarter Onboarding",
    description: " Projects can gate access using scores.",
  },
];

// const stepstostart = [
//   { imageSrc: sts3, title: "1", description: "Connect to Monad testnet" },
//   { imageSrc: sts2, title: "2", description: "Spin up your node" },
//   { imageSrc: sts3, title: "3", description: "Complete weekly challenges" },
//   { imageSrc: sts4, title: "4", description: "Stay consistent for streaks" },
//   { imageSrc: sts5, title: "5", description: "Climb the leaderboard" },
// ];
const stepstostart = [
  {
    imageSrc: sts3,
    title: "1",
    description: "Launch ScoreSwap and connect your wallet.",
  },
  {
    imageSrc: sts2,
    title: "2",
    description: "Trade on the go with Nads Trading Bot.",
  },
  {
    imageSrc: sts3,
    title: "3",
    description: "Integrate our trust layer into your project.",
  },
  {
    imageSrc: sts4,
    title: "4",
    description: "Provide liquidity and tap into aggregated volume.",
  },
  { imageSrc: sts5, title: "5", description: "Stay active to unlock the full benefits." },
];

const Home = () => {
  return (
    <div className="w-full h-full">
      {/* Hero Section */}
      <section className="w-full relative py-20 sm:py-32 min-h-screen flex flex-col items-center justify-center text-center px-4 overflow-hidden">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-10 opacity-20"
        >
          <source src={herobg} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Text Content */}
        <div className="max-w-5xl relative z-10 space-y-6">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-tight sm:leading-snug">
            Your DeFi Command Center.
             {/* Powered by Monad. */}
          </h1>
          <p className="text-[#D8D8D8] max-w-2xl mx-auto text-base sm:text-lg md:text-xl">
            Score Finance brings trust, liquidity intelligence, and instant
            execution together in one suite — from aggregated DEX trading to
            on-the-go Telegram swaps.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center sm:space-x-4">
            {/* <Link to="https://dashboard.monadscore.xyz" target="_blank">
              <button className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3] font-semibold border border-[#E300F3] rounded-full transform hover:scale-x-105 transition-transform duration-500">
                Launch ScoreSwap
              </button>
            </Link> */}
            <Link to="https://t.me/nadstradebot" target="_blank">

              <button className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3] font-semibold border border-[#E300F3] rounded-full transform hover:scale-x-105 transition-transform duration-500">
                Trade with Nads Bot
              </button>
            </Link>
            <div className="relative">
              <div className="absolute -top-2 -right-2 bg-[#E300F3] text-white text-xs px-2 py-1 rounded-full z-10">Soon</div>
              <button
                disabled
                className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3]/50 font-semibold border border-[#E300F3]/50 rounded-full cursor-not-allowed opacity-60"
              >
                Launch ScoreSwap
              </button>
            </div>
            {/* <div className="relative" target="_blank">
              <div className="absolute -top-2 -right-2 bg-[#E300F3] text-white text-xs px-2 py-1 rounded-full z-10">Closed</div>

              <button className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3] font-semibold border border-[#E300F3] rounded-full transform hover:scale-x-105 transition-transform duration-500 cursor-not-allowed opacity-60">
                Run Trust Node
              </button>
            </div> */}


            {/* <div className="relative">
              <div className="absolute -top-2 -right-2 bg-[#E300F3] text-white text-xs px-2 py-1 rounded-full z-10">Soon</div>
              <button
                disabled
                className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3]/50 font-semibold border border-[#E300F3]/50 rounded-full cursor-not-allowed opacity-60"
              >
                Trade with Nads Bot
              </button>
            </div> */}
          </div>
        </div>

    

        {/* <a href="/check-whitelist" className="px-8 z-50 cursor-pointer w-full mt-20 whitespace-nowrap sm:px-12 py-3 bg-white/0 bg-[#E300F3] text-white  font-semibold border border-white transform scale-x-105 hover:scale-x-105 transition-transform duration-500">
          Check Whitelist
        </a> */}
   
      </section>



      {/* Why Score Finance */}
      <section className="w-full py-20 sm:py-40 min-h-screen flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
        {/* Background image aligned to the right */}
        <img
          src={whybg}
          alt="Why Score Finance Background"
          className="absolute top-0 right-0 h-full object-cover object-right z-10"
        />

        <div className="max-w-6xl space-y-6">
          {/* Text */}
          <p className="text-white text-6xl sm:text-[150px] font-bold -m-36 text-outline">
            Why
          </p>

          <h2 className="text-4xl sm:text-6xl text-white font-semibold leading-snug">
            Why Score Finance
          </h2>
          <p className="text-[#D8D8D8] max-w-3xl mx-auto text-base sm:text-lg md:text-xl">
            Web3 moves fast — but without trust, precision, and liquidity,
            you’re just guessing. Score Finance combines
          </p>

          {/* Grid for the 3 items */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 sm:mt-10">
            <div className="px-8 py-6 bg-white/0 text-white border border-white rounded-xl transform hover:scale-x-105 transition-transform duration-500">
              <h3 className="text-[#E300F3]">Trust Layer </h3>
              <p> Verify and reward real users.</p>
            </div>
            <div className="px-8 py-6 bg-white/0 text-white border border-white rounded-xl transform hover:scale-x-105 transition-transform duration-500">
              <h3 className="text-[#E300F3]">Liquidity Layer </h3>
              <p> Aggregated DEX prices so you always get the best rates.</p>
            </div>
            <div className="px-8 py-6 bg-white/0 text-white border border-white rounded-xl transform hover:scale-x-105 transition-transform duration-500">
              <h3 className="text-[#E300F3]">Execution Layer </h3>
              <p> Swap instantly from your browser or Telegram.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="w-full py-20 sm:py-40 min-h-screen flex flex-col items-center justify-center text-center px-4">
        <div className="max-w-6xl space-y-6">
          {/* Text */}
          <p className="text-white text-6xl sm:text-[100px] font-bold -mb-16 sm:-mb-36 text-outline">
            Features
          </p>
          <h2 className="text-4xl sm:text-6xl text-white font-semibold leading-snug">
            Key Features
          </h2>
          <p className="text-[#D8D8D8] max-w-3xl mx-auto text-base sm:text-lg md:text-xl">
            Your Reputation = Your Score
          </p>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 sm:mt-20 max-w-7xl w-full px-4">
            {howitworksData.map((item, index) => (
              <HowItWorksCard
                key={index}
                imageSrc={item.imageSrc}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full py-20 sm:py-40 min-h-screen flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
        {/* Full-height image aligned to the left */}
        <img
          src={mattersbg}
          alt="Why It Matters Background"
          className="absolute top-0 left-0 h-full object-cover object-left z-10"
        />

        <div className="max-w-6xl space-y-6">
          {/* Text */}
          <p className="text-white text-6xl sm:text-[150px] font-bold -m-24 sm:-m-36 text-outline">
            Best Trades
          </p>
          <h2 className="text-4xl sm:text-6xl text-white font-semibold leading-snug">
            The Best Trades. Backed by Trust.
          </h2>
          <p className="text-[#D8D8D8] max-w-3xl mx-auto text-lg sm:text-2xl md:text-2xl">
            With Score Finance, every action is optimized for performance and
            integrity
          </p>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-6 mt-12 sm:mt-20 max-w-7xl w-full px-4 text-left">
            {/* First 3 cards */}
            {whyitmattersCard.slice(0, 3).map((item, index) => (
              <WhyItMattersCard
                key={index}
                imageSrc={item.imageSrc}
                title={item.title}
                description={item.description}
              />
            ))}

            {/* Last 2 cards centered */}
            <div className="col-span-full flex justify-center gap-6 mt-6 sm:mt-12 flex-wrap sm:flex-nowrap">
              {whyitmattersCard.slice(3).map((item, index) => (
                <div className="w-full sm:w-auto">
                  <WhyItMattersCard
                    key={index + 3}
                    imageSrc={item.imageSrc}
                    title={item.title}
                    description={item.description}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Start Earning Reputation */}
      <section className="w-full py-20 sm:py-40 min-h-screen flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
        {/* Top-right background image */}
        <img
          src={startbg}
          alt="Start Background Top Right"
          className="absolute top-0 right-0 w-[300px] sm:w-[500px] lg:w-[600px] opacity-50 z-10"
        />

        {/* Bottom-left background image */}
        <img
          src={startbg}
          alt="Start Background Bottom Left"
          className="absolute bottom-0 left-0 w-[300px] sm:w-[500px] lg:w-[600px] opacity-50 z-10"
        />

        <div className="max-w-6xl space-y-6">
          {/* Text */}
          <p className="text-white text-6xl sm:text-[100px] font-bold -m-16 sm:-m-36 text-outline">
            Start
          </p>
          <h2 className="text-4xl sm:text-6xl text-white font-semibold">
            Start Trading Smarter
          </h2>
          <p className="text-[#D8D8D8] max-w-2xl mx-auto text-lg sm:text-2xl md:text-3xl">
            Get on-chain. Stay active. Get recognized.
          </p>
          {/* 
          <h3 className="text-4xl sm:text-5xl text-white font-semibold py-12 sm:py-16">
            Steps to Start:
          </h3> */}

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-6 mt-12 sm:mt-16 max-w-7xl w-full px-4">
            {stepstostart.map((item, index) => (
              <div key={index} className="flex justify-center">
                <div
                  className={
                    index % 2 === 0 ? "sm:ml-24 lg:ml-48" : "sm:mr-24 lg:mr-48"
                  }
                >
                  <StepsToStart
                    imageSrc={item.imageSrc}
                    title={item.title}
                    description={item.description}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ready to build */}
      <section className="w-full py-20 sm:py-40 flex flex-col items-center justify-center text-center px-4 relative ">
        <img
          src={readybg}
          alt="Ready Background"
          className="absolute inset-0 z-[-20] w-full h-full object-cover"
        />

        <div className="max-w-6xl space-y-6">
          <p className="text-white text-6xl sm:text-[100px] font-bold -m-16 sm:-m-36 text-outline">
            Ready
          </p>
          <h2 className="text-4xl sm:text-6xl text-white font-semibold">
            Ready to Level Up Your DeFi Experience?
          </h2>
          <p className="text-[#D8D8D8] max-w-2xl mx-auto text-lg sm:text-2xl md:text-3xl">
            The future of trading onchain starts here — powered by Score Finance, ScoreSwap, and Nads Trading Bot.
          </p>

          <div className="space-y-4 sm:space-x-4 flex flex-col sm:flex-row items-center justify-center flex-wrap sm:space-y-0 sm:flex sm:justify-center sm:flex-wrap mt-6">
            {/* <Link to="https://monadscore.xyz" className="z-40" target="_blank">

              <button className="px-12 cursor-pointer py-3 bg-white/0 text-white border border-white rounded-full transform hover:scale-x-105 hover:bg-[#620268] transition-transform duration-500 w-full sm:w-auto">

                Launch ScoreSwap
              </button>
            </Link> */}
            <div className="relative">
              <div className="absolute -top-2 -right-2 bg-[#E300F3] text-white text-xs px-2 py-1 rounded-full z-10">Soon</div>
              <button
                disabled
                className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3]/50 font-semibold border border-[#E300F3]/50 rounded-full cursor-not-allowed opacity-60"
              >
                Launch ScoreSwap
              </button>
            </div>

            {/* <Link to="https://repute.monadscore.xyz" className="z-40" target="_blank">
              <button className="px-12 py-3 bg-white/0 text-white border border-white rounded-full transform hover:scale-x-105  hover:bg-[#620268] transition-transform duration-500 w-full sm:w-auto">
                Trade with Nads Bot
              </button>
            </Link> */}
            {/* <div className="relative">
              <div className="absolute -top-2 -right-2 bg-[#E300F3] text-white text-xs px-2 py-1 rounded-full z-10">Soon</div>
              <button
                disabled
                className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3]/50 font-semibold border border-[#E300F3]/50 rounded-full cursor-not-allowed opacity-60"
              >
                Trade with Nads Bot
              </button>
            </div> */}

            <Link className="cursor-pointer" to="https://t.me/nadstradebot" target="_blank">

              <button className="px-8 sm:px-12 py-3 bg-white/0 text-[#E300F3] font-semibold border border-[#E300F3] rounded-full transform hover:scale-x-105 transition-transform duration-500">
                Trade with Nads Bot
              </button>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
